import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Block from './Block';
import NewsList from './NewsList';

const PageNewsList = ({ content, selectedLocale }) => (
  <Block
    id={content.internal_link_id}
    py={{ mobile: 'baseUp4', tablet: 'baseUp12' }}
  >
    <NewsList selectedLocale={selectedLocale} withTitle={false} />
  </Block>
);

PageNewsList.propTypes = {
  content: PropTypes.shape({
    internal_link_id: PropTypes.string,
  }).isRequired,
  selectedLocale: PropTypes.string.isRequired,
};

export default PageNewsList;

export const query = graphql`
  fragment PageNewsListFragment on PrismicPageBodyNewsList {
    id
    slice_type
    primary {
      internal_link_id
    }
  }
`;
